module.exports = __webpack_public_path__ + "img/coupe.bc01c3f4.svg";